const basemaps = [
  {
    id: 0,
    type: 'TileLayer',
    source: {
      type: 'XYZSource',
      config: {
        crossOrigin: 'Anonymous',
        attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
      }
    },
    thumbnail: 'https://www.arcgis.com/sharing/rest/content/items/1254ac139ecf423fbb04020bc57025a5/info/thumbnail/topo_map_2.jpg',
    name: 'Topographic'
  },
  {
    id: 1,
    type: 'TileLayer',
    source: {
      type: 'XYZSource',
      config: {
        crossOrigin: 'Anonymous',
        attributions: 'Tiles © <a href="https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'
      }
    },
    thumbnail: 'https://www.arcgis.com/sharing/rest/content/items/04e903465a3e497aa669212e08927cee/info/thumbnail/world_street_map.jpg',
    name: 'Streets'
  },
  {
    id: 2,
    type: 'TileLayer',
    source: {
      type: 'XYZSource',
      config: {
        crossOrigin: 'Anonymous',
        attributions: 'Tiles © <a href="https://server.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer">ArcGIS</a>',
        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
      }
    },
    thumbnail: 'https://www.arcgis.com/sharing/rest/content/items/52bdc7ab7fb044d98add148764eaa30a/info/thumbnail/thumbnail1576867503263.jpeg',
    name: 'Imagery'
  },
  {
    id: 3,
    type: 'Group',
    name: 'Imagery with labels',
    thumbnail: 'https://www.arcgis.com/sharing/rest/content/items/3027a41ed46d4a9b915590d14fecafc0/info/thumbnail/imagery_labels.jpg',
    layers: [
      {
        id: 1,
        type: 'TileLayer',
        source: {
          type: 'XYZSource',
          config: {
            crossOrigin: 'Anonymous',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
          }
        },
        name: 'Base'
      },
      {
        id: 2,
        type: 'TileLayer',
        source: {
          type: 'XYZSource',
          config: {
            crossOrigin: 'Anonymous',
            attributions: 'Tiles © <a href="https://server.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer">ArcGIS</a>',
            url: 'https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}'
          }
        },
        name: 'Transportation'
      },
      {
        id: 3,
        type: 'TileLayer',
        source: {
          type: 'XYZSource',
          config: {
            crossOrigin: 'Anonymous',
            attributions: 'Tiles © <a href="https://server.arcgisonline.com/arcgis/rest/services/Canvas/World_Light_Gray_Reference/MapServer">ArcGIS</a>',
            url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}'
          }
        },
        name: 'Boundaries'
      }
    ]
  }
]

export default basemaps
